import { Button, Modal, Box } from '@mui/material';
import { useAtom, useSetAtom } from 'jotai';
import { SketchPicker } from 'react-color';
import { backGroundColorMainScreen, openSketcher } from '../../common/atom/atoms';
export default function Sketcher() {
  const [background, setBackground] = useAtom(backGroundColorMainScreen);
  const [modal, setModal] = useAtom(openSketcher);

  const handleChangeComplete = (color) => {
    setBackground(color.hex);
  };

  return (
    <Modal
      open={modal}
      onClose={() => setModal(false)}
      sx={{ zIndex: 1202, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Box
        sx={{
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 2,
          outline: 'none',
          width: 'fit-content', // Let it fit the content
        }}
      >
        <SketchPicker color={background} onChangeComplete={handleChangeComplete} />
        <Button
          color="error"
          variant="contained"
          sx={{ marginTop: 2, width: '100%' }} // now it matches SketchPicker width
          onClick={() => setModal(false)}
        >
          Close
        </Button>
      </Box>
    </Modal>
  );
}
